import { AgencyPerfermanceOverviewReportRequestModel } from '../api/models/AgencyPerfermanceOverviewReportPage';
import { AgencyPerfermanceOverviewReportFormModel, GroupedByEnum } from '../models';

export const dataFormToRequest = (
  data: AgencyPerfermanceOverviewReportFormModel
): AgencyPerfermanceOverviewReportRequestModel => ({
  from: data.from,
  to: data.to,
  room_type_ids: data.room_type_ids,
  market_ids: data.market_code_ids,
  market_segment_ids: data.segment_market_code_ids,
  card_ids: data.cards.map(card => card.id),
  with_revenue: data.with_revenue,
  currency_application: data.currency_application ?? undefined,
  currency_id: data?.with_revenue && data.currency ? Number(data.currency.id) : null,
  fixed_at: data?.with_revenue && data?.fixed_at ? Number(data?.fixed_at) : null,
  grouped_by: data.grouped_by === GroupedByEnum.NONE ? null : data.grouped_by,
  gross_revenue: data?.with_revenue ? data?.gross_revenue : false,
  file_type: data?.file_type,
});
